import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SuperAdminDashboard from '../components/Dashboard/SuperAdminDashboard';
import { ROLES } from '../constants/roles';
import DoctorDashboard from '../components/Dashboard/DoctorDashboard';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <div>Loading...</div>;
  }

  switch (user.role) {
    case ROLES.DOCTOR:
      return <DoctorDashboard />;
    case ROLES.SUPERADMIN:
      return <SuperAdminDashboard />;
    default:
      return <div>Unknown user role</div>;
  }
};

export default Dashboard;
